import React, { useState, useEffect } from "react"
import Model from "../../Models/Model.js"
const AuthContext = React.createContext()
function AuthProvider(props) {
    const [user, setUser] = useState({});
    useEffect(() => { 
        const api = new Model();
        api.postReq('/token/verify',{},(values) =>{
            if (values === null) {
                setUser({
                    isAuthenticated : false
                })
                return
            }
            if (values.success) {
                var newUser = values.value
                newUser.isAuthenticated = true
                setUser(newUser)
            } else {
                setUser({
                    isAuthenticated : false
                })
            }
        })
    }, user.isAuthenticated)

    return (
        <AuthContext.Provider value={{user, setUser}} {...props} >
            {props.children}
        </AuthContext.Provider>
    )
}
function authenticate(username, password, setUser, callback) {
    const api = new Model();
    api.postReq('/login',{
        username: username,
        password : password
    },(values,err) => {
        if (values && values.success) {
            const val = values.value
            api.postReq('/token/verify',{
                token : val.token
            },(values) =>{
                if (values === null) {
                    callback(false,{
                        isAuthenticated : false
                    })
                    return
                }
                if (values.success) {
                    var newUser = values.value
                    newUser.isAuthenticated = true
                    setUser(newUser)
                } else {
                    setUser({
                        isAuthenticated : false
                    })
                }
                callback(values.success,newUser)
            })
        } else {
            setUser({
                isAuthenticated : false
            })
            callback(values && values.success,{
                isAuthenticated : false
            })
        }
    })
}
function logout(setUser) {
    const api = new Model();
    api.postReq('/logout',{},(values) =>{})
    setUser({
        isAuthenticated : false
    })
}
const useAuth = () => React.useContext(AuthContext)
function withAuthManager(Component) {
    const C = props => {
      const { wrappedComponentRef, ...remainingProps } = props;
      return (
        <AuthContext.Consumer>
          {({user, setUser}) => {
                return (
                <Component
                    {...remainingProps}
                    user = {user} 
                    setUser = {setUser}
                    ref={wrappedComponentRef}
                />
                );
          }}
        </AuthContext.Consumer>
      );
    };
    C.WrappedComponent = Component;
    return C;
}
export {AuthProvider, useAuth, AuthContext, authenticate, logout, withAuthManager}